import { Injectable } from '@angular/core';
//import { HttpClient } from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { HeaderDataSource, PagedResult } from '../../../lib/ng-crud-table';
import { DataSort, DataFilter } from '../../../lib/ng-data-table/base';
import { arrayPaginate, formatDate, lastDateFunc } from '../../../lib/common/utils';
import { NotifyService } from '../../../lib/notify/notify.service';
import { Observable, Subject } from 'rxjs';
import { Key } from 'protractor';
import { CommonFilterService } from './services/common-filter/common-filter.service';
import { CommonFilter, GeneralFilter } from './models/Common/common-filter';
import { environment } from 'src/environments/environment';

//https://hassantariqblog.wordpress.com/2016/12/03/angular2-http-simple-get-using-promises-in-angular-2-application/
//https://medium.com/@gparlakov/rxjs-operator-topromise-waits-for-your-observable-to-complete-e7a002f5dccb

@Injectable({
  providedIn: 'root'
})
export class HeaderDemoService implements HeaderDataSource {
  url: string = 'assets/ng-crud-table/players.json';

  primaryKeys: string[] = ['id'];

  private dataFilter: DataFilter;
  private dataSort: DataSort;

  private commonFilter: CommonFilter;
  private generalFilterArray: Array<GeneralFilter>;

  constructor(private http: HttpClient, private notifyService: NotifyService, private commonFilterService: CommonFilterService) {
    this.dataFilter = new DataFilter();
    this.dataSort = new DataSort();

    this.commonFilter = new CommonFilter();
    this.generalFilterArray = [];
  }

  //https://stackoverflow.com/questions/46903190/how-to-wait-for-return-of-a-function-in-typescript
  //https://dev.to/viniciuskneves/yet-another-post-about-asyncawait-and-promises-49gg
  //https://stackoverflow.com/questions/45057278/angular-4-settimeout-does-not-wait
  //http://www.learn-it-with-examples.com/development/html-css-javascript/angular/settimeout-angular-example.html
  //https://medium.com/@balramchavan/using-async-await-feature-in-angular-587dd56fdc77
  //https://www.techiediaries.com/javascript-async-await-tutorial/
  //https://stackoverflow.com/questions/43304316/rxjs-observable-interval-and-angular2-http-wait-for-response
  //https://stackoverflow.com/questions/45057278/angular-4-settimeout-does-not-wait
  //https://www.reddit.com/r/Angular2/comments/94fyme/problem_using_observableinterval_with_angular6/
  //async getTotalRecords(dates, dateOperator, rsltType): Promise<number> {
  getTotalRecords(rsltType): Observable<number> {
    //let dates = formatDate(new Date(Date.now() + -1 * 600 * 1000)) + "^" + formatDate(new Date());//"06/02/2019 11:00:00^06/02/2019 20:00:00";  
    //this.commonFilterService.TSBetween.subscribe(res => dates = res);

    //let dateOperator = "6";
    //let arrDates = this.dataFilter.filteringDates();//make proper dates string to be passed to db
    //const boolDateFilterSelected = ((arrDates.length == 2) || (arrDates.length == 0));
    //if (boolDateFilterSelected) {
    //  if (arrDates.length == 0)
    //    this.commonFilterService.TSRangeSelected.subscribe(res => dates = lastDateFunc(res));
    //  else {
    //    dates = arrDates[0];
    //    dateOperator = arrDates[1];
    //  }
    //}
    //this.commonFilterService.setDatesProperties(dates);

    //this.commonFilter.TimestampType = "1";
    //this.commonFilter.TimestampRange = dates;
    //this.commonFilter.Operator = dateOperator;
    //this.commonFilter.SortByOrder = "descending";
    ////let params = new HttpParams()
    ////  .set('TSType', '1')
    ////  .set('TSBetween', dates)
    ////  .set('Operator', dateOperator);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headers
    };
    this.url = environment.urlAddress + '/api/' + rsltType + '/Post' + rsltType + 'Count';
    //return await this.http.get<number>(this.url, { params })
    return this.http.post<number>(this.url, JSON.stringify({ commonFilter: this.commonFilter, generalFilterArray: this.generalFilterArray }), options);
  }

  getItems(PerPage, CurrentPage, rsltType): Observable<any> {
    const currentPage = CurrentPage; 
    const perPage = PerPage;
    //let dateOperator = "6";

    //this.commonFilter.TimestampType = "1";
    //this.commonFilterService.TSBetween.subscribe(res => this.commonFilter.TimestampRange = res);
    //this.commonFilter.Operator = dateOperator;
    //this.commonFilter.PageNumber = currentPage.toString();
    //this.commonFilter.PerPage = perPage.toString();
    //this.commonFilter.SortByOrder = "descending";

    ////let params = new HttpParams()
    ////  .set('TSType', '1')
    ////  .set('PageNumber', currentPage.toString())
    ////  .set('PerPage', perPage.toString())
    ////  .set('TSBetween', dates)
    ////  .set('Operator', dateOperator)
    ////  .set('Sort', 'descending');    
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headers
    };

    this.url = environment.urlAddress + '/api/' + rsltType + '/Post' + rsltType;
    //return this.http.get<PagedResult>(this.url, { params })
    //https://www.techiediaries.com/angular-http-client/
    //https://stackoverflow.com/questions/50330342/how-to-send-post-in-angular5-with-multiple-params
    //https://weblog.west-wind.com/posts/2012/May/08/Passing-multiple-POST-parameters-to-Web-API-Controller-Methods
    //https://www.dotnetcurry.com/aspnet/1278/aspnet-webapi-pass-multiple-parameters-action-method
    return this.http.post<any>(this.url, JSON.stringify({ commonFilter: this.commonFilter, generalFilterArray: this.generalFilterArray }), options);
  }

  post(item: any): Promise<any> {
    return new Promise((resolve) => {
      setTimeout(() => resolve(item), 250);
    });
  }

  put(item: any): Promise<any> {
    return new Promise((resolve) => {
      setTimeout(() => resolve(item), 250);
    });
  }

  delete(item: any): Promise<any> {
    return new Promise((resolve) => {
      setTimeout(() => resolve(item), 250);
    });
  }

  getOptions(url: string, parentId: any): Promise<any> {
    return this.http.get(url)
      .toPromise()
      .then((response: any) => {
        const result = response.filter((value: any) => {
          return value.parentId === parentId;
        });
        return new Promise((resolve) => {
          setTimeout(() => resolve(result), 1000);
        });
      })
      .catch(this.handleError);
  }

  private handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    this.notifyService.sendMessage({ title: 'HttpErrorResponse', text: errorMessage, severity: 'error' });
    return Promise.reject(errorMessage);
  }

}
